(function ($) {

var observer = lozad();
var scroll_fix = 0;
var scroll_time_fix;

observer.observe();

    $(document).ready(function () {

        // autoscroll on desktop
        if($(window).width() > 1024 && $(window).scrollTop() === 0) {
            function pageScroll() {
                $('html, body').stop().animate({
                    scrollTop: (500)
                }, 1000);
            }

            setTimeout(function() {
                pageScroll();
            }, 2000);
        }

        if($('.home').length > 0) {
            //remove all before #
            $('header a[href*=#]').each(function(){
                $(this).attr('href','#'+$(this).attr('href').split('#')[1]);
            });
        }

        $('a[href^=#]').on('click', function(event) {
            var target = $(this.getAttribute('href'));
            if( target.length ) {
                event.stopPropagation();
                event.preventDefault();
                $('html, body').stop().animate({
                    scrollTop: (target.offset().top)
                }, 1000);
            }

            //hide submenu
            if($(window).width() < 1170) {
                $('header').find('nav').fadeOut().removeClass('visible');
                $('header').find('button').removeClass('active').attr('aria-expanded', 'false');
            }
        });

        $(window).trigger('resize');
    });


    $(window).on('resize', function(){
        manageScrollMenu();

         if($('.fixme').length > 0) {

            if(document.documentMode || /Edge/.test(navigator.userAgent)) {
                $('.fixme').addClass('relative');
            }
            
            switchPosition($('.fixme'));
        }
    });

    function manageScrollMenu(){
        if($(window).width() <= 768) {
            $('#displayMenu').show();
            openMenu($('#displayMenu'), $('#displayMenu').parent().find('nav'));
            closeAfterLastTab($('#displayMenu').parent().find('nav'));
        }

        else {
            $('#nav ul').show();
            $('#displayMenu').hide();
        }
    }

    //fix block when scroll is on it
    function switchPosition(selector) {

        if(document.documentMode || /Edge/.test(navigator.userAgent)) {
            if(selector.length > 1) {
                selector.each(function(index,elem){
                    $(elem).attr('data-position', $(elem).offset().top);
                });

                $(document).scroll(function() {
                    var current_scroll = $(window).scrollTop();
                    selector.each(function(ind,el) {
                        if(current_scroll >=  $(el).attr('data-position')) {
                            $(el).addClass('sticky');    
                        }
                        else {
                            $(el).removeClass('sticky');  
                        }
                    });
                });
            }

            else {
                var selectorPosition = $(selector).offset().top;
                $(document).scroll(function() {
                    var current_scroll = $(window).scrollTop();
                    if(current_scroll >= selectorPosition) {
                        $(selector).addClass('sticky');    
                    }
                    else {
                        $(selector).removeClass('sticky');  
                    }
                });
            }
        }
    }

    function openMenu(trigger, target) {
        trigger.unbind('click').click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (target.is(':visible')) {
                target.fadeOut().removeClass('visible');
                trigger.attr('aria-expanded', 'false').removeClass('active');
            }
            else {
                target.fadeIn().addClass('visible');
                trigger.attr('aria-expanded', 'true').addClass('active');
                target.find('a').first().focus();
            }
        });
    }

    function closeAfterLastTab(selector) {
        selector.keydown(function (e) {
            
            if (e.keyCode === 9) {
                var focusedElement = $(':focus');
                
                if (e.shiftKey === false && focusedElement.is($(this).find(':tabbable').last())) {
                    $(this).prev().trigger('click');
                    $(this).prev().parent().next().find(':tabbable').first().focus();
                    e.preventDefault();
                }
            }
            else if(focusedElement.is($(this).find(':tabbable').first())) {
                $(this).prev().trigger('click');
                $(this).prev().parent().prev().find(':tabbable').first().focus();
                e.preventDefault();
            }
        });
}

})(jQuery);

 window.dataLayer = window.dataLayer || [];
 function gtag(){dataLayer.push(arguments);}
 gtag('js', new Date());

 gtag('config', 'UA-115368698-2');